import * as tinycolor from 'tinycolor2';

// the tinycolor module exports differently in the browser environment vs the nodejs environment
export default tinycolor?.default || tinycolor;
